import { Box, Stack, Typography } from '@mui/material';
import { NablaLogo } from 'assets/images';
import { Outlet } from 'react-router-dom';

const AuthLayout = () => {
  return (
    <Box>
      <Box sx={{ textAlign: 'left', padding: '85px 81px 0' }}>
        <Box
          component='img'
          src={NablaLogo}
          sx={{ width: '314px', objectFit: 'contain' }}
        />
      </Box>
      <Stack
        justifyContent='center'
        alignItems='center'
        sx={{
          width: '100%',
          height: 'calc(100% - 166px)',
          py: '20px',
        }}
      >
        <Typography
          sx={{
            color: '#1a96f0',
            fontSize: '50px',
            fontWeight: '700',
            textAlign: 'center',
            marginBottom: '27px',
          }}
        >
          SIGNAGE STATISTICS
        </Typography>
        <Outlet />
      </Stack>
    </Box>
  );
};

export default AuthLayout;
